import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { useNavAction } from "hooks";

export const RefetchButton = () => {
  const action = useNavAction();
  if (!action) return null;

  return (
    <Link className="button" to="#" onClick={action.onClick}>
      <Icon className="arrows rotate regular i-grey" />
    </Link>
  );
};
